import { render, staticRenderFns } from "./claimsIndex.vue?vue&type=template&id=0595759c&scoped=true"
import script from "./claimsIndex.vue?vue&type=script&lang=js"
export * from "./claimsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0595759c",
  null
  
)

export default component.exports